import React, { Component } from 'react'
import uuid from 'uuid'
import * as api from '../../lib/api'

const Zone = props => {
  const { top, left, right, bottom } = props.dimension
  return (
    <div
      style={{
        position: 'absolute',
        top: Math.min(top, bottom) + 'px',
        left: Math.min(left, right) + 'px',
        height: Math.abs(bottom - top) + 'px',
        width: Math.abs(left - right) + 'px',
        backgroundColor: 'rgba(255,255,255,0.1)',
        border: '1px dashed white',
        boxShadow: '1px 1px 12px #555',
        color: 'white',
        textShadow: `-1px 0 0 rgba(0, 0, 0, 0.8), 
        1px 0 0 rgba(0, 0, 0, 0.8), 
        0 -1px 0 rgba(0, 0, 0, 0.8), 
        0 1px 0 rgba(0, 0, 0, 0.8)`,

        textAlign: 'center',
        zIndex: 1,
        overflow: 'hidden',
        borderRadius: '6px',
        pointerEvents: 'none'
      }}
    >
      {props.children}
    </div>
  )
}

const Circle = props => {
  let { top, left, radius } = props.dimension
  radius = radius || 30
  return (
    <div
      style={{
        position: 'absolute',
        top: top - radius + 'px',
        left: left - radius + 'px',
        width: radius * 2 + 'px',
        height: radius * 2 + 'px',
        paddingTop: radius - 10 + 'px',
        borderRadius: radius + 'px',
        backgroundColor: 'rgba(255,255,255,0.25)',
        border: '1px dashed #333',
        color: '#333',
        textAlign: 'center',
        zIndex: 1
      }}
    >
      {props.children}
    </div>
  )
}

export class ZoneOnPicture extends Component {
  imageWrapperRef = React.createRef()

  state = {
    dimension: null,
    loading: false,
    imgLoaded: false,
    drawing: false,
    current: null,
    resizing: null,
    moving: null,
    zones: [],
    resource: {}
  }

  populateResource(resourceUid) {
    if (!resourceUid || resourceUid.indexOf('__transfert__') === 0) {
      return
    }
    this.setState({ loading: true })
    api.resources.get(resourceUid).then(resource => {
      resource &&
        this.setState({
          url: api.resources.getUrl(resource.hd ? resource.hd.file : resource.original.file),
          loading: false
        })
    })
  }

  getFormDataValue(formData, pathString) {
    if (!formData || !pathString) return undefined
    let path = pathString.split('.')
    let field = formData
    while (field && path.length) {
      field = field[path[0]]
      path = path.slice(1)
    }
    return field
  }

  componentDidMount() {
    const uiSchema = this.props.uiSchema || {}
    const uiOptions = uiSchema['ui:options'] || {}
    const backgroundFieldName = uiOptions.image
    const backgroundFieldValue = this.getFormDataValue(this.props.formContext.formData, backgroundFieldName)
    if (backgroundFieldValue) {
      this.populateResource(backgroundFieldValue)
    }
  }

  componentWillReceiveProps(nextProps) {
    const uiSchema = this.props.uiSchema || {}
    const uiOptions = uiSchema['ui:options'] || {}
    const backgroundFieldName = uiOptions.image

    const nextBackgroundValue = this.getFormDataValue(nextProps.formContext.formData, backgroundFieldName)

    const currentBackgroundValue = this.getFormDataValue(this.props.formContext.formData, backgroundFieldName)

    if (backgroundFieldName && !!nextBackgroundValue && currentBackgroundValue !== nextBackgroundValue) {
      this.populateResource(nextBackgroundValue)
    }
  }

  normalizeZones(zones) {
    if (!this.state.imgLoaded) {
      return null
    }
    const { width, height } = this.state.dimension
    return zones.map(zone => {
      return {
        top: zone.top / height,
        bottom: (zone.bottom || 0) / height,
        right: (zone.right || 0) / width,
        left: zone.left / width,
        _id: zone._id
      }
    })
  }

  denormalizeZone(zones, width, height) {
    const dnorm = zones.map(zone => {
      return {
        top: zone.top * height,
        bottom: (zone.bottom || zone.top + 0.1) * height,
        right: (zone.right || zone.left + 0.1) * width,
        left: zone.left * width,
        _id: zone._id
      }
    })
    return dnorm
  }

  imgLoaded = e => {
    const uiSchema = this.props.uiSchema
    const uiOptions = uiSchema ? uiSchema['ui:options'] : {}
    const drawCircle = uiOptions && uiOptions.zoneShape === 'circle'

    this.setState({
      dimension: {
        width: e.target.offsetWidth,
        height: e.target.offsetHeight
      },
      drawCircle,
      zones: this.denormalizeZone(this.props.formData || [], e.target.offsetWidth, e.target.offsetHeight) || [],
      imgLoaded: true
    })
  }

  getRelativePoint = e => {
    const wrapper = this.imageWrapperRef.current
    if (!wrapper) {
      return { x: e.nativeEvent.offsetX, y: e.nativeEvent.offsetY }
    }
    const rect = wrapper.getBoundingClientRect()
    return { x: e.clientX - rect.left, y: e.clientY - rect.top }
  }

  findZoneAtPoint = (x, y) => {
    const { zones } = this.state
    for (let i = zones.length - 1; i >= 0; i -= 1) {
      const zone = zones[i]
      if (this.state.drawCircle) {
        const radius = zone.radius || 30
        const dx = x - zone.left
        const dy = y - zone.top
        if (dx * dx + dy * dy <= radius * radius) {
          return i
        }
      } else {
        const left = Math.min(zone.left, zone.right)
        const right = Math.max(zone.left, zone.right)
        const top = Math.min(zone.top, zone.bottom)
        const bottom = Math.max(zone.top, zone.bottom)
        if (x >= left && x <= right && y >= top && y <= bottom) {
          return i
        }
      }
    }
    return -1
  }

  startMove = (index, point) => {
    const zone = this.state.zones[index]
    if (!zone) {
      return
    }
    if (this.state.drawCircle) {
      this.setState({
        moving: {
          index,
          offsetX: point.x - zone.left,
          offsetY: point.y - zone.top
        }
      })
    } else {
      const left = Math.min(zone.left, zone.right)
      const top = Math.min(zone.top, zone.bottom)
      this.setState({
        moving: {
          index,
          offsetX: point.x - left,
          offsetY: point.y - top
        }
      })
    }
    window.addEventListener('mousemove', this.onMoveMove)
    window.addEventListener('mouseup', this.onMoveEnd)
  }

  moveZone = (x, y) => {
    const { moving, zones, dimension } = this.state
    if (!moving || !dimension) {
      return zones
    }
    const nextZones = zones.slice()
    const zone = { ...nextZones[moving.index] }
    if (this.state.drawCircle) {
      const radius = zone.radius || 30
      const clampX = Math.min(dimension.width - radius, Math.max(radius, x - moving.offsetX))
      const clampY = Math.min(dimension.height - radius, Math.max(radius, y - moving.offsetY))
      zone.left = clampX
      zone.top = clampY
    } else {
      const left = Math.min(zone.left, zone.right)
      const right = Math.max(zone.left, zone.right)
      const top = Math.min(zone.top, zone.bottom)
      const bottom = Math.max(zone.top, zone.bottom)
      const width = right - left
      const height = bottom - top
      const newLeft = Math.min(dimension.width - width, Math.max(0, x - moving.offsetX))
      const newTop = Math.min(dimension.height - height, Math.max(0, y - moving.offsetY))
      zone.left = newLeft
      zone.top = newTop
      zone.right = newLeft + width
      zone.bottom = newTop + height
    }
    nextZones[moving.index] = zone
    return nextZones
  }

  onMoveMove = e => {
    e.preventDefault()
    const point = this.getRelativePoint(e)
    const zones = this.moveZone(point.x, point.y)
    this.setState({ zones })
  }

  onMoveEnd = e => {
    e.preventDefault()
    const normalized = this.normalizeZones(this.state.zones)
    this.props.onChange(normalized)
    this.setState({ moving: null })
    window.removeEventListener('mousemove', this.onMoveMove)
    window.removeEventListener('mouseup', this.onMoveEnd)
  }

  startResize = (index, handle, e) => {
    if (!this.state.imgLoaded) {
      return
    }
    e.preventDefault()
    e.stopPropagation()
    this.setState({ resizing: { index, handle } })
    window.addEventListener('mousemove', this.onResizeMove)
    window.addEventListener('mouseup', this.onResizeEnd)
  }

  getResizeCursor = handle => {
    return handle === 'ne' || handle === 'sw' ? 'nesw-resize' : 'nwse-resize'
  }

  onResizeMove = e => {
    e.preventDefault()
    const point = this.getRelativePoint(e)
    const zones = this.resizeZone(point.x, point.y)
    this.setState({ zones })
  }

  onResizeEnd = e => {
    e.preventDefault()
    const normalized = this.normalizeZones(this.state.zones)
    this.props.onChange(normalized)
    this.setState({ resizing: null })
    window.removeEventListener('mousemove', this.onResizeMove)
    window.removeEventListener('mouseup', this.onResizeEnd)
  }

  resizeZone = (x, y) => {
    const { resizing, zones, dimension } = this.state
    if (!resizing || !dimension) {
      return zones
    }
    const minSize = 10
    const nextZones = zones.slice()
    const zone = { ...nextZones[resizing.index] }
    const left = Math.min(zone.left, zone.right)
    const right = Math.max(zone.left, zone.right)
    const top = Math.min(zone.top, zone.bottom)
    const bottom = Math.max(zone.top, zone.bottom)
    const clampX = Math.min(dimension.width, Math.max(0, x))
    const clampY = Math.min(dimension.height, Math.max(0, y))

    if (resizing.handle === 'nw') {
      zone.left = Math.min(clampX, right - minSize)
      zone.top = Math.min(clampY, bottom - minSize)
      zone.right = right
      zone.bottom = bottom
    } else if (resizing.handle === 'ne') {
      zone.left = left
      zone.top = Math.min(clampY, bottom - minSize)
      zone.right = Math.max(clampX, left + minSize)
      zone.bottom = bottom
    } else if (resizing.handle === 'sw') {
      zone.left = Math.min(clampX, right - minSize)
      zone.top = top
      zone.right = right
      zone.bottom = Math.max(clampY, top + minSize)
    } else if (resizing.handle === 'se') {
      zone.left = left
      zone.top = top
      zone.right = Math.max(clampX, left + minSize)
      zone.bottom = Math.max(clampY, top + minSize)
    }

    nextZones[resizing.index] = zone
    return nextZones
  }

  onMouseDown = e => {
    if (!this.state.imgLoaded) {
      return
    }
    const point = this.getRelativePoint(e)
    const hitIndex = this.findZoneAtPoint(point.x, point.y)
    if (hitIndex >= 0) {
      e.preventDefault()
      this.startMove(hitIndex, point)
      return
    }
    e.preventDefault()
    this.setState({
      current: {
        top: point.y,
        left: point.x,
        bottom: point.y,
        right: point.x,
        _id: uuid.v4()
      },
      drawing: true
    })
    window.addEventListener('mousemove', this.onDrawMove)
    window.addEventListener('mouseup', this.onDrawEnd)
  }

  onDrawMove = e => {
    if (!this.state.imgLoaded || !this.state.drawing) {
      return
    }
    e.preventDefault()
    const current = this.state.current
    if (!current) {
      return
    }
    const point = this.getRelativePoint(e)
    const clampX = Math.min(this.state.dimension.width, Math.max(0, point.x))
    const clampY = Math.min(this.state.dimension.height, Math.max(0, point.y))
    current.right = clampX
    current.bottom = clampY
    this.setState({ current })
  }

  onDrawEnd = e => {
    if (!this.state.imgLoaded || !this.state.drawing) {
      return
    }

    const uiSchema = this.props.uiSchema
    const uiOptions = uiSchema ? uiSchema['ui:options'] : {}
    const drawCircle = uiOptions && uiOptions.zoneShape === 'circle'

    e.preventDefault()
    const current = this.state.current

    let zones = this.state.zones.slice()
    if (drawCircle || (Math.abs(current.top - current.bottom) > 10 && Math.abs(current.left - current.right) > 10)) {
      if (this.state.drawCircle) {
        const center = {
          top: Math.min(current.top, current.bottom),
          left: Math.min(current.left, current.right),
          _id: current._id
        }
        zones = zones.concat(center)
      } else {
        const ordered = {
          top: Math.min(current.top, current.bottom),
          left: Math.min(current.left, current.right),
          right: Math.max(current.left, current.right),
          bottom: Math.max(current.top, current.bottom),
          _id: current._id
        }
        zones = zones.concat(ordered)
      }
      const normalized = this.normalizeZones(zones)
      this.props.onChange(normalized)
    } else {
      zones = this.state.zones
    }
    this.setState({ drawing: false, zones, current: null })
    window.removeEventListener('mousemove', this.onDrawMove)
    window.removeEventListener('mouseup', this.onDrawEnd)
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.onResizeMove)
    window.removeEventListener('mouseup', this.onResizeEnd)
    window.removeEventListener('mousemove', this.onMoveMove)
    window.removeEventListener('mouseup', this.onMoveEnd)
    window.removeEventListener('mousemove', this.onDrawMove)
    window.removeEventListener('mouseup', this.onDrawEnd)
  }

  onDblClick = e => {
    const x = e.nativeEvent.offsetX
    const y = e.nativeEvent.offsetY
    const zones = this.state.zones.slice().filter(zone => {
      if (this.state.drawCircle) {
        return x < zone.left - 20 || x > zone.left + 20 || y < zone.top - 20 || y > zone.top + 20
      }

      return (
        x < Math.min(zone.left, zone.right) ||
        x > Math.max(zone.left, zone.right) ||
        y < Math.min(zone.top, zone.bottom) ||
        y > Math.max(zone.top, zone.bottom)
      )
    })
    this.props.onChange(this.normalizeZones(zones))
    this.setState({ zones })
  }

  render() {
    if (this.state.loading) {
      return <span>chargement </span>
    }

    const { current, zones, dimension } = this.state

    const uiSchema = this.props.uiSchema || {}
    const uiOptions = uiSchema['ui:options'] || {}
    const showPixels = uiOptions.showPixels || false
    const drawedZones = []
    const resizeHandles = []
    const handleSize = 10
    const activeCursor = this.state.resizing
      ? this.getResizeCursor(this.state.resizing.handle)
      : this.state.moving
      ? 'move'
      : this.state.drawing
      ? 'crosshair'
      : null
    zones &&
      zones.forEach((zone, index) => {
        if (!this.state.drawCircle) {
          const left = Math.min(zone.left, zone.right)
          const right = Math.max(zone.left, zone.right)
          const top = Math.min(zone.top, zone.bottom)
          const bottom = Math.max(zone.top, zone.bottom)
          const handles = [
            { key: 'nw', x: left, y: top, cursor: 'nwse-resize' },
            { key: 'ne', x: right, y: top, cursor: 'nesw-resize' },
            { key: 'sw', x: left, y: bottom, cursor: 'nesw-resize' },
            { key: 'se', x: right, y: bottom, cursor: 'nwse-resize' }
          ]
          handles.forEach(handle => {
            resizeHandles.push(
              <div
                key={index + '-' + handle.key}
                onMouseDown={e => this.startResize(index, handle.key, e)}
                style={{
                  position: 'absolute',
                  left: handle.x - handleSize / 2 + 'px',
                  top: handle.y - handleSize / 2 + 'px',
                  width: handleSize + 'px',
                  height: handleSize + 'px',
                  background: '#fff',
                  border: '1px solid #333',
                  borderRadius: '2px',
                  boxShadow: '0 0 2px rgba(0, 0, 0, 0.4)',
                  zIndex: 6,
                  cursor: activeCursor || handle.cursor,
                  pointerEvents: activeCursor ? 'none' : 'auto'
                }}
              />
            )
          })
        }
        if (this.state.drawCircle) {
          drawedZones.push(
            <Circle key={index} dimension={zone}>
              Zone {index + 1}
            </Circle>
          )
        } else {
          if (zone.right > dimension.width) {
            drawedZones.push(
              <Zone
                key={index + 'overflow'}
                dimension={{
                  left: Math.max(0, zone.left - dimension.width),
                  right: zone.right - dimension.width,
                  bottom: zone.bottom,
                  top: zone.top
                }}
              >
                Zone {index + 1}
              </Zone>
            )

            if (zone.left < dimension.width) {
              drawedZones.push(
                <Zone
                  key={index}
                  dimension={{
                    left: zone.left,
                    right: dimension.width,
                    bottom: zone.bottom,
                    top: zone.top
                  }}
                >
                  Zone {index + 1}
                </Zone>
              )
            }
          } else {
            drawedZones.push(
              <Zone key={index} dimension={zone}>
                Zone {index + 1}
              </Zone>
            )
          }
        }
      })
    return (
      <div className="form-group field field-string">
        <label className="control-label" htmlFor={this.props.name}>
          {this.props.schema.title}
        </label>
        <p>dessinez les zones sur l'image à la souris, double cliquez sur une zone pour l'effacer</p>
        <div style={{ position: 'relative' }}>
          <div ref={this.imageWrapperRef} style={{ position: 'relative', flex: '1', marginRight: '265px', minHeight: '200px' }}>
            <img
              alt="background of dropzone"
              src={this.state.url}
              key="img"
              style={{ maxWidth: '100%', display: 'block', boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.25)' }}
              onLoad={this.imgLoaded}
            />
            {current && (this.state.drawCircle ? <Circle dimension={current} /> : <Zone dimension={current} />)}
            {drawedZones}
            {resizeHandles}
            {dimension && (
              <div
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: dimension.width + 'px',
                  height: dimension.height + 'px',
                  zIndex: 5,
                  ...(activeCursor ? { cursor: activeCursor } : {})
                }}
                onMouseDown={this.onMouseDown}
                onDoubleClick={this.onDblClick}
              />
            )}
          </div>
          {showPixels && (
            <div style={{ position: 'absolute', width: '250px', right: 0, top: 0, bottom: 0, overflow: 'scroll' }}>
              {zones &&
                zones.map((zone, index) => {
                  return (
                    <div key={zone._id}>
                      <h3>Zone {index + 1}</h3>
                      <div style={{ display: 'flex' }}>
                        <label style={{ flex: '50px 0 0' }}>haut</label>
                        <input
                          type="number"
                          className="form-control"
                          value={parseInt(zone.top)}
                          step="1"
                          onChange={e => {
                            const top = parseInt(e.target.value, 10)
                            zones[index].top = top
                            const normalized = this.normalizeZones(zones)
                            this.props.onChange(normalized)
                            this.setState({ zones })
                          }}
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <label style={{ flex: '50px 0 0' }}>gauche</label>
                        <input
                          type="number"
                          className="form-control"
                          value={parseInt(zone.left)}
                          step="1"
                          onChange={e => {
                            const left = parseInt(e.target.value, 10)
                            zones[index].left = left
                            const normalized = this.normalizeZones(zones)
                            this.props.onChange(normalized)
                            this.setState({ zones })
                          }}
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <label style={{ flex: '50px 0 0' }}>bas</label>
                        <input
                          type="number"
                          className="form-control"
                          value={parseInt(zone.bottom)}
                          step="1"
                          onChange={e => {
                            const bottom = parseInt(e.target.value, 10)
                            zones[index].bottom = bottom
                            const normalized = this.normalizeZones(zones)
                            this.props.onChange(normalized)
                            this.setState({ zones })
                          }}
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <label style={{ flex: '50px 0 0' }}>droite</label>
                        <input
                          type="number"
                          className="form-control"
                          value={parseInt(zone.right)}
                          step="1"
                          onChange={e => {
                            const right = parseInt(e.target.value, 10)
                            zones[index].right = right
                            const normalized = this.normalizeZones(zones)
                            this.props.onChange(normalized)
                            this.setState({ zones })
                          }}
                        />
                      </div>
                      largeur : {Math.round(zone.right - zone.left)} / hauteur : {Math.round(zone.bottom - zone.top)}
                      <br />
                    </div>
                  )
                })}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export class ZonePicker extends Component {
  listZones(formData, path) {
    let field = formData
    while (field && path && path.length) {
      field = field[path[0]]
      path = path.slice(1)
    }
    return field || []
  }

  findZoneField(uiSchema) {
    const uiOptions = this.props.uiSchema['ui:options'] || {}
    if (uiOptions.from) {
      return uiOptions.from.split('.')
    }
    let path = null
    if (!uiSchema) {
      return null
    }
    if (!Array.isArray(uiSchema) && typeof uiSchema !== 'object') {
      return null
    }
    if (uiSchema['ui:field'] === 'zoneonpicture') {
      path = []
    }

    Object.keys(uiSchema).forEach(key => {
      if (path === null) {
        const subPath = this.findZoneField(uiSchema[key])
        if (subPath !== null) {
          path = [key].concat(subPath)
        }
      }
    })
    return path
  }

  change = e => {
    this.props.onChange(e.target.value)
  }

  render() {
    const zonefieldPath = this.findZoneField(this.props.formContext.uiSchema)
    const zones = this.listZones(this.props.formContext.formData, zonefieldPath)
    const options = (zones || []).map((zone, index) => (
      <option key={index} value={zone._id}>
        Zone {index + 1}
      </option>
    ))
    return (
      <div className="form-group field field-string">
        <label className="control-label" htmlFor={this.props.name}>
          {this.props.schema.title}
        </label>
        <select
          className="form-control"
          value={this.props.formData}
          onChange={this.change}
          readOnly={this.props.readonly}
          disabled={this.props.disabled}
        >
          <option />
          {options}
        </select>
      </div>
    )
  }
}
